import React from 'react';
import { Box } from '@mui/material';
import styles from './card.module.scss';
import CardStatusTag from './card-status-tag';

interface CardProps {
    title: React.ReactNode;
    statusText: string;
    children: React.ReactNode;
    isStatusActive?: boolean;
    actions?: React.ReactNode;
}

export const Card: React.FC<CardProps> = ({
    title,
    statusText,
    children,
    isStatusActive = true,
    actions,
}) => (
    <Box className={styles.wrapper}>
        <div className={styles.card}>
            <div className={styles.info}>
                <div className={styles.titleRow}>
                    <span className={styles.title}>{title}</span>
                    <CardStatusTag label={statusText} isActive={isStatusActive} />
                </div>
                <div className={styles.description}>{children}</div>
            </div>
            {actions ? (
                <div className={styles.actions}>
                    {actions}
                </div>
            ) : null}
        </div>
    </Box>
);

export default Card;
